import { queryOptions } from "@tanstack/react-query";
import { api, ApiError, type CustomerAccount } from "./api";
import type { AuthState } from "./auth/AuthProvider";

export const meQueryOptions = (auth: AuthState) =>
  queryOptions<CustomerAccount | null>({
    queryKey: ["me", auth.user?.uid],
    queryFn: async () => {
      try {
        return await api.me(auth);
      } catch (e) {
        if (e instanceof ApiError && e.status === 404) return null; // no account yet → /register
        throw e;
      }
    },
    staleTime: 5 * 60_000,
  });

export const businessesQueryOptions = (auth: AuthState) =>
  queryOptions({
    queryKey: ["me", auth.user?.uid, "businesses"],
    queryFn: () => api.businesses(auth),
  });

export const consentTextsQueryOptions = () =>
  queryOptions({ queryKey: ["consent-texts"], queryFn: () => api.consentTexts(), staleTime: Infinity });
